import { setUser } from "@sentry/solid";

import Api from "@repo/api";
import USentry from "@repo/telemetry/USentry";

import { Registration, track } from "~/analytics/client";

USentry.initSolid({
  enabled: !!import.meta.env.SENTRY_DSN,
  dsn: import.meta.env.SENTRY_DSN,
  environment:
    import.meta.env.STAGING === "true" ? "staging" : import.meta.env.APP_ENV,
  apiOrigin: Api.origin,
  tombstoneDeduperUrl: `${import.meta.env.TOMBSTONE_DEDUPER_ORIGIN}/sentry-event`,
  beforeSend({ event, frames, suppress }) {
    // Track in amplitude to see raw data for suppression
    track("sentry: send", {
      message: event.exception?.values?.[0]?.value,
      filestack: frames?.map(({ filename }) => filename),
      frames,
      suppress,
    });

    return suppress ? null : event;
  },
});

export default (): Registration.Other => {
  return {
    identify({ userId }) {
      if (userId) setUser({ id: userId, ip_address: "{{auto}}" });
    },
    anonymize() {
      setUser(null);
    },
    track() {
      // Do nothing
    },
  };
};
